<template>
  <TheHeaderMobile
    :site-logo="siteLogo"
    :search="searchData"
    :without-analyses-cart="withoutAnalysesCart"
    :analyses-count-in-cart="analysesCountInCart"
    :expert-url="expertUrl"
    :available-languages="availableLanguages"
    :town-select-url="townSelectUrl"
    :projects="projects"
    :personal-area-url="personalAreaUrl"
    data-qa="the_header"
  />
</template>

<script setup lang="ts">
import TheHeaderMobile from 'src/layouts/core-layout/components/CoreHeader/components/mobile/TheHeader/TheHeaderMobile.vue'
import useTheHeader from 'src/layouts/core-layout/components/CoreHeader/components/mobile/TheHeader/composables/useTheHeader'

const {
  siteLogo,
  searchData,
  withoutAnalysesCart,
  analysesCountInCart,
  expertUrl,
  availableLanguages,
  townSelectUrl,
  projects,
  personalAreaUrl,
} = useTheHeader()
</script>
